module.exports = vendor.React;


//////////////////
// WEBPACK FOOTER
// external "vendor.React"
// module id = 1
// module chunks = 0